import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState('');
  const [selectedTask, setSelectedTask] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetch("https://task-list-api-java.onrender.com/api/tasks/")
      .then(response => response.json())
      .then(data => {
        setTasks(data);
      })
      .catch(error => {
        console.error('Error fetching tasks:', error);
      });
  }, []);

  const handleAddTask = () => {
    if (newTask.trim() !== '') {
      fetch("https://task-list-api-java.onrender.com/api/tasks", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ task: newTask, completed: false }),
      })
        .then(response => response.json())
        .then(data => {
          setTasks([...tasks, data]);
          setNewTask('');
        })
        .catch(error => {
          console.error('Error adding task:', error);
        });
    }
  };

  const handleDeleteTask = (id) => {
    fetch(`https://task-list-api-java.onrender.com/api/tasks/${id}`, {
      method: 'DELETE',
    })
      .then(response => response.json())
      .then(data => {
        setTasks(tasks.filter(task => task.id !== id));
      })
      .catch(error => {
        console.error('Error deleting task:', error);
      });
  };

  const handleToggleComplete = (id) => {
    const updatedTasks = tasks.map(task => {
      if (task.id === id) {
        return { ...task, completed: !task.completed };
      }
      return task;
    });
    setTasks(updatedTasks);
  };

  const handleOpenModal = (task) => {
    setSelectedTask(task);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedTask(null);
    setShowModal(false);
  };

  const handleUpdateTask = () => {
    fetch(`https://task-list-api-java.onrender.com/api/tasks/${selectedTask.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(selectedTask),
    })
      .then(response => response.json())
      .then(data => {
        const updatedTasks = tasks.map(task => {
          if (task.id === selectedTask.id) {
            return selectedTask;
          }
          return task;
        });
        setTasks(updatedTasks);
        handleCloseModal();
      })
      .catch(error => {
        console.error('Error updating task:', error);
      });
  };

  return (
    <div className="container mt-5">
      <h1>Task List</h1>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Enter task..."
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
        />
        <div className="input-group-append">
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleAddTask}
          >
            Add Task
          </button>
        </div>
      </div>
      <ul className="list-group mt-3">
        {tasks.map(task => (
          <li key={task.id} className="list-group-item d-flex justify-content-between align-items-center">
            <span style={{ textDecoration: task.completed ? 'line-through' : 'none' }}>{task.task}</span>
            <div>
              <button
                className="btn btn-warning mr-2"
                onClick={() => handleToggleComplete(task.id)}
              >
                {task.completed ? 'Mark Incomplete' : 'Mark Complete'}
              </button>
    
              <button
                className="btn btn-secondary mr-2"
                onClick={() => handleOpenModal(task)}
              >
                Update
              </button>

              <button
                className="btn btn-danger"
                onClick={() => handleDeleteTask(task.id)}
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>

      {/* Update Task Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            value={selectedTask ? selectedTask.task : ''}
            onChange={(e) => setSelectedTask({ ...selectedTask, task: e.target.value })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdateTask}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TaskList;
